import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { PersonalInformationUrlComponent } from './shared/components/personal-information-url/personal-information-url.componente';
import { HistoryWhatsapp } from './distributor/components/whatsapp/history-whatsapp/history-whatsapp.component';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  // { path: 'unauthorized', loadChildren: () => import('./error/error.module').then(m => m.ErrorModule) },
  {
    path: 'distributor',
    loadChildren: () =>
      import('./distributor/distributor.module').then(
        (m) => m.DistributorModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'eps',
    loadChildren: () => import('./eps/eps.module').then((m) => m.EpsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'patients',
    loadChildren: () =>
      import('./patients/patients.module').then((m) => m.PatientsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'lab',
    loadChildren: () => import('./lab/lab.module').then((m) => m.LabModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'vitales',
    loadChildren: () =>
      import('./vitales/vitales.module').then((m) => m.VitalesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./onboarding/onboarding.module').then((m) => m.OnboardingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'adverseReport',
    loadChildren: () =>
      import('./eventos-adversos/eventos-adversos.module').then(
        (m) => m.EventosAdversosModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'logistica',
    loadChildren: () =>
      import('./logistica/logistica.module').then((m) => m.LogisticaModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'logistics_dashboard',
    loadChildren: () =>
      import('./logistics-dashboard/logistics-dashboard.module').then((m) => m.LogisticsDashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'validar-paciente',
    component: PersonalInformationUrlComponent, // o un componente específico si lo prefieres
    // no agregues AuthGuard
  },
  {
    path: 'what',
    component: HistoryWhatsapp, // o un componente específico si lo prefieres
    // no agregues AuthGuard
  },
  {
    path: 'informes',
    loadChildren: () =>
      import('./informes/informes.module').then((m) => m.InformesModule),
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
